import Project from "../project/Project";
import {
  Bottom,
  Container,
  Section1,
  Section2,
  Title,
  Top,
} from "./Projects.Element";

const Projects = () => {
  return (
    <Container id='projects'>
      <Top>
        <Title>PROJECTS</Title>
      </Top>
      <Bottom>
        <Section1>
          <Project side='left' />
        </Section1>
        <Section2>
          <Project side='right' />
        </Section2>
      </Bottom>
    </Container>
  );
};

export default Projects;
